import { Packages } from '~shared/constants/pricing';

import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';

import GROW2529FeatureListMapTreatment1 from '~app/pages/Pricing/experiments/grow_2529_forms/treatment1/transformers/summary/features';
import GROW2529FeatureListMapTreatment2 from '~app/pages/Pricing/experiments/grow_2529_forms/treatment2/transformers/summary/features';

import { PremierAnnualFeatureList, PremierAnnualOverrideRules } from './premierAnnualFeatureList';
import { StandardMonthlyFeatureList, StandardMonthlyOverrideRules } from './standardMonthlyFeatureList';
import { StarterMonthlyFeatureList, StarterAnnualOverrideRules } from './starterAnnualFeatureList';
import { FlexFeatureList, FlexFeatureOverrideRules } from './flexPlanFeatureList';

import AdvantageAnnualFeatureList from './advantageAnnualFeatureList';
import EnterpriseFeatureList from './enterpriseFeatureList';
import TeamPremierFeatureList from './teamPremierFeatureList';

import { FeatureListMap } from '../types';

/**
 * All feature list configuration mapping. See the FeatureListMap for how to set up the config object.
 * It is advisable to import experiment feature list config from the experiment subfolder of your experiment.
 * Failure to provide the correct config can result in incorrect UI and business logic presentation.
 * We also encourage all new package or package name change to define their own feature list.
 */
const FeatureList: FeatureListMap = {
  [EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.treatment]: {
    // forms v2 uses the same summary features
    ...GROW2529FeatureListMapTreatment1[EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment1],
  },
  ...GROW2529FeatureListMapTreatment1,
  ...GROW2529FeatureListMapTreatment2,
  default: {
    [Packages.StarterAnnual]: {
      list: [...StandardMonthlyFeatureList, ...StarterMonthlyFeatureList],
      rules: StarterAnnualOverrideRules,
    },
    [Packages.StandardMonthly]: {
      list: StandardMonthlyFeatureList,
      rules: StandardMonthlyOverrideRules,
    },
    [Packages.Flex]: {
      list: [...StandardMonthlyFeatureList, ...FlexFeatureList],
      rules: FlexFeatureOverrideRules,
    },
    [Packages.AdvantageAnnual]: {
      list: AdvantageAnnualFeatureList,
    },
    [Packages.PremierAnnual]: {
      list: [...AdvantageAnnualFeatureList, ...PremierAnnualFeatureList],
      rules: PremierAnnualOverrideRules,
    },
    [Packages.TeamAdvantage]: {
      list: [],
    },
    [Packages.TeamPremier]: {
      list: TeamPremierFeatureList,
    },
    [Packages.Enterprise]: {
      list: [...TeamPremierFeatureList, ...EnterpriseFeatureList],
    },
  },
};

export default FeatureList;
